/** Map an ISO 3166-1 alpha-2 code (e.g. "PT") to an English country name (e.g. "Portugal").
 * Falls back to the raw code if it can't be resolved. */
export function operatorCountryName(code: string | null | undefined): string | null {
  if (!code) return null;
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(code.toUpperCase()) ?? code;
  } catch {
    return code;
  }
}
